// --- common f(): 3
/*
  wordString: backpack 背包 / backpack
  level: "low", "mid", "high"
  return: "word: b......k 背包" @ level == "low"
*/
export function dotWordMidChars(wordString, level) {
  //console.log("wordString: ", wordString, level);
  const spacedDot = " .";
  let word = '', retString ='';

  const wordArr = wordString.split(" ");
  word = wordArr[0]; word = word.trim();
  const charArr = word.split("");

  if (word.length == 1) {   // a, I
    retString = "word: .";
  } else if (word.length == 2) {  // me, 
    retString = "word: " + charArr[0] + spacedDot;
  } else {
    for (let i=1; i<charArr.length -1; i++){
      charArr[i] = spacedDot;
    }
    if (wordArr.length > 1 && level == "low") {
      retString = "word:" + charArr.join("")+ " " + wordArr[1];
    } else if (level == "high") {
      charArr[charArr.length -1] = spacedDot;
      retString = "word:" + charArr.join("");
    } else {  // mid & low
      retString = "word:" + charArr.join("");
    }
  }


  return retString
}

export function axiosEH(err) {
//console.log(JSON.stringify(err));
let errMsg;
if (err.response) {	// the server respond status code out of 2xx
  errMsg = err.response.data;	// status,  headers
} else if (err.request) {      // no response was received
  errMsg = err.request;
} else {	 // error in setting up the request that triggered an Error
  errMsg = err.message;
}
return errMsg;
}

export function showResultArr(arr) {
// arr[0] is table head, arr[len-1] is filename
const titleStr = "Wrong spell words list (correct word, wrong spell;)";
const remindStr ="Please refer to the report file for details";
let spellErrArr =[], resultStr ='"';
let errMsgArr = [titleStr], temp;
//console.log('arr:', arr.length, arr); 

// wrong spell only
for (let i=1; i<arr.length; i++){
  //console.log('arr len, typeof, value :', arr[i].length, typeof arr[i], arr[i]); 
  //if (arr[i][3] == "v") continue;   // bug
  if (typeof(arr[i]) == 'string' || arr[i][3] == "v" ) continue;
  spellErrArr.push([arr[i][1], arr[i][2]] );
}
//console.log('spellErrArr:', spellErrArr); 
if (spellErrArr.length ==0) return;

// 4-column show; 2-column: i += 1
for (let i=0; i<spellErrArr.length; i +=2){
  temp =spellErrArr[i].join(",")
  if (i+1 < spellErrArr.length) {
    temp += ";  " + spellErrArr[i+1].join(",")
  }
  errMsgArr.push(temp)
}
errMsgArr.push(remindStr);
resultStr = errMsgArr.join("\n");
alert(resultStr);
}

// user level saved in localstorage named as username
export function getCurrentLevel(username) {
  let userLevel = localStorage.getItem(username);
  //console.log(`userLevel:  + ${userLevel}`);

  if ( userLevel == 'low' || userLevel == 'mid' || userLevel == 'high') {
    return userLevel;
  } else {
    userLevel = "low";  localStorage.setItem(username, userLevel);
    return userLevel;
  }
}

// cal userLevel (score), save & ret it
export function setCurrentLevel(username, score) {
  let userLevel;
  console.log(`${username} + ${score}`);

  const scoreInt = parseInt(score)
  if (scoreInt < 75) {
    userLevel = "low";  localStorage.setItem(username, userLevel);
  } else if (scoreInt > 85) {
    userLevel = "high";  localStorage.setItem(username, userLevel);
  }  else {
    userLevel = "mid";  localStorage.setItem(username, userLevel);
  }
  if (localStorage.getItem(username) !=  userLevel ) console.log("userLevel error");
  
  return userLevel;
}

// not used
export function deleteKeysAfter(obj, startKey) {
  let foundStartKey = false;
  for (const key in obj) {
    if (key === startKey) {
      foundStartKey = true;
      continue; // Skip the startKey itself
    }
    if (foundStartKey) {
      delete obj[key];
    }
  }
  return obj;
}

export function deleteKeysStartingWith(obj, prefix) {
  for (const key in obj) {
    // Ensure the property belongs to the object itself, not its prototype chain
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      if (key.startsWith(prefix)) {
        delete obj[key];
      }
    }
  }
  return obj;
}